import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.settings');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-settings',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.settings/view.scss */
/* src/app/page.settings/view.scss: no such file or directory */`],
})
export class PageSettingsComponent implements OnInit {
    public loading: boolean = true;
    public saving: boolean = false;
    public validating: any = { gemini: false, openai: false };
    public validation: any = { gemini: null, openai: null };
    public error: string = '';
    public settings: any = this.defaultSettings();
    public form: any = {
        gemini_api_key: '',
        openai_api_key: '',
    };

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        if (!this.service.auth.allow('/access')) return;
        await this.load();
    }

    public canManage() {
        const role = String(this.service.auth.session?.role || '').toLowerCase();
        return ['system', 'admin'].includes(role);
    }

    public defaultSettings() {
        return {
            gemini: {
                api_key_configured: false,
                api_key_source: 'missing',
                api_key_verified: false,
                api_key_verified_at: '',
                api_key_last_checked_at: '',
                api_key_last_check_status: '',
                model: 'gemini-3.5-flash',
            },
            openai: {
                api_key_configured: false,
                api_key_source: 'missing',
                api_key_verified: false,
                api_key_verified_at: '',
                api_key_last_checked_at: '',
                api_key_last_check_status: '',
                embedding_model: 'text-embedding-3-small',
            },
        };
    }

    public applySettings(settings: any) {
        const defaults = this.defaultSettings();
        this.settings = {
            gemini: { ...defaults.gemini, ...(settings?.gemini || {}) },
            openai: { ...defaults.openai, ...(settings?.openai || {}) },
        };
        this.syncForm();
    }

    public async load() {
        if (!this.canManage()) {
            this.error = '시스템관리자만 설정을 변경할 수 있습니다.';
            this.loading = false;
            await this.service.render();
            return;
        }

        this.loading = true;
        this.error = '';
        await this.service.render();

        try {
            const result = await wiz.call('load');
            const code = result?.code;
            const data = result?.data || result || {};
            if (code === 200 || code === '200' || code === undefined) {
                this.applySettings(data.settings || {});
            } else {
                this.applySettings({});
                this.error = data?.message || '설정을 불러오지 못했습니다.';
            }
        } catch (error: any) {
            this.applySettings({});
        }

        this.loading = false;
        await this.service.render();
    }

    public syncForm() {
        this.form = {
            gemini_api_key: '',
            openai_api_key: '',
        };
    }

    public async save() {
        if (!this.canManage() || this.saving) return;
        this.saving = true;
        this.error = '';
        await this.service.render();

        try {
            const result = await wiz.call('save', this.form);
            const code = result?.code;
            const data = result?.data || {};
            if (code === 200 || code === '200' || code === undefined) {
                this.applySettings(data.settings || result?.settings || {});
                this.validation = { gemini: null, openai: null };
                await this.service.modal.success(data?.message || result?.message || '설정을 저장했습니다.');
            } else {
                await this.service.modal.error(data?.message || result?.message || '설정 저장에 실패했습니다.');
            }
        } catch (error: any) {
            await this.service.modal.error(error?.message || '설정 저장에 실패했습니다.');
        }

        this.saving = false;
        await this.service.render();
    }

    public providerKey(provider: string) {
        return provider === 'gemini' ? this.form.gemini_api_key : this.form.openai_api_key;
    }

    public canValidate(provider: string) {
        return this.canManage()
            && !this.loading
            && !this.saving
            && !this.validating?.[provider]
            && !!String(this.providerKey(provider) || '').trim();
    }

    public clearValidation(provider: string) {
        this.validation[provider] = null;
    }

    public validationClass(result: any) {
        return result?.valid
            ? 'border-emerald-200 bg-emerald-50 text-emerald-700'
            : 'border-rose-200 bg-rose-50 text-rose-700';
    }

    private decodeResponse(response: any) {
        if (typeof response === 'string') {
            try {
                return JSON.parse(response);
            } catch (_error) {
                return { message: response };
            }
        }
        return response || {};
    }

    private responseEnvelope(response: any) {
        const data = this.decodeResponse(response);
        const responseText = String(data?.responseText || '').trim();
        const body = this.decodeResponse(data?.responseJSON || (responseText.startsWith('{') ? responseText : data));
        return body?.data || body || {};
    }

    private validationPayload(response: any) {
        const payload = this.responseEnvelope(response);
        return payload?.validation || payload;
    }

    private validationFallbackMessage(response: any, payload: any, valid: boolean) {
        if (valid) return 'API 키가 유효합니다.';
        const code = response?.code ?? payload?.code ?? payload?.status ?? response?.status;
        if (code === 401 || code === '401' || code === 403 || code === '403') {
            return '관리자 로그인 세션을 확인해주세요.';
        }
        if (code) return `API 키 확인 응답을 확인해주세요. 상태: ${code}`;
        return '검증 응답에 결과가 없습니다.';
    }

    public async validate(provider: string) {
        if (!this.canValidate(provider)) return;
        this.validating[provider] = true;
        this.validation[provider] = null;
        await this.service.render();

        try {
            const apiKey = String(this.providerKey(provider) || '').trim();
            const result = await wiz.call('save', {
                verify_provider: provider,
                verify_only: 'true',
                api_key: apiKey,
                gemini_api_key: provider === 'gemini' ? apiKey : '',
                openai_api_key: provider === 'openai' ? apiKey : '',
            });
            const envelope = this.responseEnvelope(result);
            const payload = this.validationPayload(result);
            const valid = payload?.valid === true || payload?.valid === 'true' || payload?.valid === 1 || payload?.valid === '1';
            if (envelope?.settings?.[provider]) {
                this.settings = {
                    ...this.settings,
                    [provider]: {
                        ...(this.settings?.[provider] || {}),
                        ...envelope.settings[provider],
                    },
                };
            }
            this.validation[provider] = {
                valid,
                message: payload?.message || this.validationFallbackMessage(result, payload, valid),
                checked_at: payload?.checked_at || '',
                verified_at: payload?.verified_at || '',
            };
        } catch (error: any) {
            this.validation[provider] = {
                valid: false,
                message: error?.message || this.validationFallbackMessage(error, {}, false),
            };
        }

        this.validating[provider] = false;
        await this.service.render();
    }

    public sourceLabel(source: string) {
        switch (source) {
            case 'stored': return '저장됨';
            case 'env': return '환경변수';
            default: return '미설정';
        }
    }

    public keyStorageLabel(item: any) {
        if (!item?.api_key_configured) return '미설정';
        return item?.api_key_source === 'env' ? '환경변수 사용' : '저장됨';
    }

    public verificationTimeLabel(value: any) {
        const text = String(value || '').trim();
        return text || '인증 기록 없음';
    }

    public verificationTextClass(item: any) {
        return item?.api_key_verified ? 'font-semibold text-emerald-700' : 'font-semibold text-gray-500';
    }

    public keyStatusClass(configured: boolean) {
        return configured ? 'border-emerald-200 bg-emerald-50 text-emerald-700' : 'border-rose-200 bg-rose-50 text-rose-700';
    }
}

export default PageSettingsComponent;